const listToOptions = <T>(list: T[]): { label: T; value: T }[] =>
  (list || []).map((label) => ({ label, value: label }));

export default listToOptions;
